// extracted by mini-css-extract-plugin
export default {"termsContent":"TermsModal_termsContent_lJsIW","section":"TermsModal_section_m5esq","actions":"TermsModal_actions_o4zFi","closeButton":"TermsModal_closeButton_fWY4Q"};